import * as _4 from 'lodash4';
import { ConversationFilterStrategy } from '../../../src/strategies/conversation_filter_strategy';
import { ConversationsCapabilityConfiguration } from '../../configuration';

export class ConversationFilterController {
  private conversationFilters: any;
  private headerTheme: string;
  private filter: string;
  private filterExpanded: boolean = false;

  constructor(
    private ngConversationsCapabilityConfiguration: ConversationsCapabilityConfiguration,
    private $state: ng.ui.IStateService
  ) {
    this.conversationFilters = ConversationFilterStrategy;
    this.headerTheme = this.ngConversationsCapabilityConfiguration.config.navIconTheme;
  }

  toggleFilter() {
    this.filterExpanded = !this.filterExpanded;
  }

  isFilteringActive(): boolean {
    return (
      !_4.isEmpty(this.filter) &&
      ConversationFilterStrategy.getByKey(this.filter) !== ConversationFilterStrategy.getByOrdinal(0)
    );
  }

  updateFilter(filter: string): void {
    this.$state.go('my.conversations', { filter });
  }
}
export class ConversationFilterComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-conversations/src/components/conversation_filter/conversation_filter.html';
  public controller: any = ConversationFilterController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    filter: '<?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/components/conversation_filter/conversation_filter_controller.ts